// extracted by mini-css-extract-plugin
export var bgImg = "textImage-module--bgImg--oNP2W";
export var gridImgTextContainer = "textImage-module--gridImgTextContainer--Z-ELd";
export var gridTextImgLink = "textImage-module--gridTextImgLink--cN6TI";
export var gridTextImgWrapper = "textImage-module--gridTextImgWrapper--U2heY";
export var pageBuilderButton = "textImage-module--pageBuilderButton--W5QYQ";
export var pageBuilderContent = "textImage-module--pageBuilderContent--y1W4F";
export var pageBuilderImage = "textImage-module--pageBuilderImage--6X6ia";
export var pageBuilderText = "textImage-module--pageBuilderText--Dwako";
export var textImageWrapper = "textImage-module--textImageWrapper--M0z-K";